import { assert } from 'console';
import { observable } from 'mobx';
import * as configFiles from './config/*.json';

interface IConfig {
    firebase: any;
    clientName: string;
    pdfViewerKey: string;
    domains: string[];
    flowise_flow_id?: string;
    flowise_url?: string;
    flowise_api_key?: string;
}

class ConfigStore {
    readonly config: IConfig;
    constructor() {
        this.config = this.getConfigByHostname();
        assert(this.config, 'Config not found');
    }

    getConfig() {
        return this.getConfigByHostname();
    }

    getConfigByHostname(): IConfig {
        if (process.env.NODE_ENV === 'development') {
            const devConfig = 'testing';
            console.log('OVERRIDE CONFIG: ', devConfig);
            assert(
                configFiles[devConfig],
                `Config 'not found for ${devConfig}`
            );
            return configFiles[devConfig] as IConfig;
        }

        const host = window.location.hostname;
        for (const key in configFiles) {
            const config = configFiles[key] as IConfig;
            const domains = config.domains;
            if (config.domains.includes(host)) {
                console.log('Using config hostname: ', host);
                return config;
            }
        }

        return null;
    }
}

const configStore = new ConfigStore();

export const useConfig = () => {
    return configStore.config;
};
export default configStore;
